import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation, FreeMode } from 'swiper';
import './game-shop-slider.scss';
import { useDispatch, useSelector } from "react-redux";
import { getGiftPopup } from "../../../redux/actions";
import { useSwipeable } from "react-swipeable";
import { GiftPopup } from "../../popups/giftPopup/GiftPopup";
import { GameShopSlide } from "../gameShopSlide/GameShopSlide";

export const GameShopSlider = () => {
  const dispatch = useDispatch()
  const isMobile = useSelector(state => state.app.isMobile)
  const gifts = useSelector(state => state.game.gameShop.gifts);
  let count = gifts.length

  const handlers = useSwipeable({
    /*onSwipedLeft: (eventData) => mainSwiper.slideNext(),
    //onSwipedRight: (eventData) => mainSwiper.slidePrev(),
    delta: 10,
    preventDefaultTouchmoveEvent: false,
    trackTouch: true,
    trackMouse: true,
    rotationAngle: 0,*/
  });
  if (gifts.length >= 3) {
    var i = -1;
    return (
      <>
        <div className="gifts gifts__slider"  {...handlers}>
          <Swiper
            modules={[Pagination, Autoplay, Navigation, FreeMode]}
            spaceBetween={0}
            autoplay={{
              enabled: true,
              delay: 4000
            }}
            slidesPerView={isMobile ? 'auto' : 3}
            loop={true}
            loopAdditionalSlides={10}
            navigation={{
              nextEl: '.gifts__slider_next',
              prevEl: '.gifts__slider_prev',
            }}
            pagination={{
              el: '.gifts__slider_dots',
              clickable: true
            }}
            centeredSlides={true}
            slideToClickedSlide={false}
            //allowTouchMove={false}
            longSwipes={false}
            loopPreventsSlide={true}
            speed={500}
            freeMode={{
              enabled: true,
              sticky: true,
              momentum: false,
              minimumVelocity: 0.2
            }}
            onSw
            onClick={
              (swiper) => {
                const realIndex = swiper.realIndex;
                const currentSlide = swiper.activeIndex;
                const index = swiper.clickedIndex
                if (index === currentSlide) {
                  if (!swiper.animating){
                    dispatch(getGiftPopup(gifts[realIndex]));
                  }
                } else {
                  if (index === 0 || currentSlide === 0) {
                    if (currentSlide === 0) {
                      if (index === (count - 1)) {
                        swiper.slidePrev();
                      } else {
                        swiper.slideNext();
                      }
                    } else {
                      if (index === 0) {
                        if (currentSlide === (count - 1)) {
                          swiper.slideNext();
                        } else {
                          swiper.slidePrev();
                        }
                      }
                    }
                  } else {
                    if (index > currentSlide) {
                      swiper.slideNext();
                    } else {
                      swiper.slidePrev();
                    }
                  }
                }
              }
            }
            /*onSlideChangeTransitionStart={(swiper) => {
              let objs = document.getElementsByClassName('psevdo_anim');
              for (let [, obj] of Object.entries(objs)) {
                obj.classList.add('psevdo_anim_old');
              }

              objs = document.getElementsByClassName('gifts__item_' + swiper.realIndex);
              for (let [, obj] of Object.entries(objs)) {
                obj.classList.add('psevdo_anim');
              }

              objs = document.getElementsByClassName('psevdo_anim_old');
              for (let [, obj] of Object.entries(objs)) {
                obj.classList.remove('psevdo_anim');
                obj.classList.remove('psevdo_anim_old');
              }
            }}*/
            onSlideChangeTransitionEnd={(swiper) => {
            }}
          >
            {
              gifts.map((item) => {
                i++;
                return (
                  <SwiperSlide key={item.id} >
                    <GameShopSlide item={item} index={i} />
                  </SwiperSlide>
                );
              })
            }
          </Swiper>
          <div className="gifts__slider_control">
            <div className="gifts__slider_dots"></div>
          </div>
        </div>
        <GiftPopup />
      </>
    )
  }
  return (
    <>
      <div className="gifts">
        <div className="gifts__items">
          {
            gifts.map((item, index) => (
              <GameShopSlide item={item} index={index - 1} key={item.id} onClick={() => {
                dispatch(getGiftPopup(item))
              }} />
            )
            )
          }
        </div>
      </div>
      <GiftPopup />
    </>
  )
}